import React, { Dispatch, ReactElement, SetStateAction, useState } from 'react'

import { Form } from 'antd'
import { Rule } from 'antd/lib/form'
import TextArea from 'antd/lib/input/TextArea'

interface IProps {
  name: string
  label: string
  rows: number
  rules?: Rule[]
  minimumLength?: number
  length: number
  setLength: Dispatch<SetStateAction<number>>
}

const TextBox = ({
  name,
  label,
  rows,
  rules,
  minimumLength,
  length,
  setLength,
}: IProps): ReactElement => {
  return (
    <>
      <Form.Item name={name} label={label} rules={rules}>
        <TextArea
          rows={rows}
          onChange={(e) => setLength(e.target.value.length)}
        />
      </Form.Item>

      {minimumLength && length < minimumLength ? (
        <div
          style={{
            color: 'red',
            marginTop: '-25px',
          }}
        >
          Digite mais {minimumLength - length} caracteres
        </div>
      ) : null}
    </>
  )
}

export default TextBox
